import EmotionGraph from './EmotionGraph';
export default EmotionGraph;
